// Modules
import styled from 'styled-components'

interface IconProps {
    transparent?: boolean
}
interface ButtonProps {
    gap?: boolean
}

export const BackgroundColor = styled.aside`
    display: flex;
    flex-direction: column;
    background-color: #1f4fff;
    align-items: center;
    justify-content: center;
    flex: 1;
`

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #1f4fff;
    padding: 0 3.75rem;
    max-height: 768px;
`

export const IllustrationContainer = styled.div`
    display: flex;
`

export const Illustration = styled.img`
    max-width: 12rem;
    margin: 2.5rem auto;
`

export const Title = styled.h1`
    color: #fff;
    text-align: center;
    font-size: 40px;
    line-height: 48px;
    font-weight: 700;
    margin-bottom: 2.5rem;
`

export const TitleLaboratory = styled.text`
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 2rem;
`

export const ContentContainer = styled.div`
    margin: 0;
`

export const ButtonContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 24px 32px 24px 32px;
    border: 1px solid #dbe3ff;
    border-radius: 24px;
    width: 424px;
    margin: 0 auto;
    gap: 16px;
`

export const AccessText = styled.div`
    position: absolute;
    top: -10px;
    left: 5%;
    background-color: #1f4fff;
    padding: 0 8px;
    color: #fefefe;
    text-align: center;
    font-family: 'Dasa Sans';
    font-weight: 700;
    font-size: 12px;
    display: flex;
    align-items: center;
`

export const VectorImg = styled.img`
    position: absolute;
    top: -8.5px;
    right: 270px;
    width: 16px;
    height: auto;
    color: #dbe3ff;
`

export const Button = styled.button`
    background-color: white;
    border-radius: 24px;
    width: 190px;
    height: 110px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
        color: #000e40;
        font-size: 16px;
    }
`

export const Icon = styled.div<IconProps>`
    font-size: 24px;
    color: ${props => (props.transparent ? '#1616163D' : '#ff4e33')};
`

export const Chevron = styled.div<ButtonProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 34px;
    gap: ${props => (props.gap ? '75px' : '88px')};
`

export const LaboratoriesContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
`
